<template>
  <div class="chinaPayment">
    <div class="enterprise-info">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="140px"
        class="demo-ruleForm"
      >
        <div>
          <nav-title class="mt2" title="企业信息"></nav-title>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业全称:" prop="companyName">
                <el-input
                  v-model="ruleForm.companyName"
                  maxlength="300"
                  placeholder="请输入企业全称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业简称:" prop="abbreviation">
                <el-input
                  v-model="ruleForm.abbreviation"
                  maxlength="50"
                  placeholder="请输入企业简称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业地址:" prop="address">
                <el-input
                  v-model="ruleForm.address"
                  maxlength="300"
                  placeholder="请输入企业地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业邮箱:" prop="email">
                <el-input
                  v-model="ruleForm.email"
                  placeholder="请输入企业邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业规模:" prop="scale">
                <el-select
                  v-model="ruleForm.scale"
                  class="form-item"
                  placeholder="请选择企业规模"
                >
                  <el-option
                    v-for="item in scaleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码:" prop="businessLicenseNo">
                <el-input
                  v-model="ruleForm.businessLicenseNo"
                  placeholder="请输入统一社会信用代码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="营业执照生效时间:"
                prop="licensePeriodStart"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.licensePeriodStart"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="营业执照失效时间:"
                prop="licensePeriodEnd"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.licensePeriodEnd"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="ruleForm.licenseLongTernFlag"
                >
                </el-date-picker>
                <el-checkbox
                  v-model="ruleForm.licenseLongTernFlag"
                  class="is-longtime"
                  @change="checkboxChange($event, 1)"
                  >长期有效</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="营业执照附件:" prop="licensePath">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.licensePathImgurl"
                    class="previewimg"
                    @mouseenter="previewimg(ruleForm.licensePathImgurl, 1)"
                    @mouseleave="previewimg('', 1)"
                  >
                    <el-image
                      v-if="commonHandleCheck(ruleForm.licensePath) == 'pdf'"
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>
                    <el-image
                      v-else
                      ref="previewImg1"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.licensePathImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg1"
                        class="imgBtn"
                        @click="handlePreview(1)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.licensePath)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess1"
                  ></fileUpload>

                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="基本账户存款证明:" prop="baseBankPath">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.baseBankPathImgurl"
                    class="previewimg"
                    @mouseenter="previewimg(ruleForm.baseBankPathImgurl, 6)"
                    @mouseleave="previewimg('', 6)"
                  >
                    <el-image
                      v-if="commonHandleCheck(ruleForm.baseBankPath) == 'pdf'"
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>
                    <el-image
                      v-else
                      ref="previewImg6"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.baseBankPathImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg6"
                        class="imgBtn"
                        @click="handlePreview(6)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.baseBankPath)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess6"
                  ></fileUpload>
                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <nav-title class="mt2" title="法人信息"></nav-title>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法人姓名:" prop="legalName">
                <el-input
                  v-model="ruleForm.legalName"
                  maxlength="300"
                  placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件类型:" prop="certificateType">
                <el-select
                  v-model="ruleForm.certificateType"
                  class="form-item"
                  placeholder="请选择证件类型"
                >
                  <el-option
                    v-for="item in certificateTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="正面证件附件:" prop="certificatePathFront">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.certificatePathFrontImgurl"
                    class="previewimg"
                    @mouseenter="
                      previewimg(ruleForm.certificatePathFrontImgurl, 2)
                    "
                    @mouseleave="previewimg('')"
                  >
                    <el-image
                      v-if="
                        commonHandleCheck(ruleForm.certificatePathFront) ==
                        'pdf'
                      "
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>
                    <el-image
                      v-else
                      ref="previewImg2"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.certificatePathFrontImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg2"
                        class="imgBtn"
                        @click="handlePreview(2)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.certificatePathFront)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess2"
                  ></fileUpload>
                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="反面证件附件:" prop="certificatePathBack">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.certificatePathBackImgurl"
                    class="previewimg"
                    @mouseenter="
                      previewimg(ruleForm.certificatePathBackImgurl, 3)
                    "
                    @mouseleave="previewimg('')"
                  >
                    <el-image
                      v-if="
                        commonHandleCheck(ruleForm.certificatePathBack) == 'pdf'
                      "
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>

                    <el-image
                      v-else
                      ref="previewImg3"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.certificatePathBackImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg3"
                        class="imgBtn"
                        @click="handlePreview(3)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.certificatePathBack)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess3"
                  ></fileUpload>
                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="法人证件生效时间:"
                prop="certificatePeriodStart"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.certificatePeriodStart"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="法人证件失效时间:"
                prop="certificatePeriodEnd"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.certificatePeriodEnd"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="ruleForm.certificateLongTernFlag"
                >
                </el-date-picker>
                <el-checkbox
                  v-model="ruleForm.certificateLongTernFlag"
                  class="is-longtime"
                  @change="checkboxChange($event, 2)"
                  >长期有效</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="证件号码:" prop="certificateNo">
                <el-input
                  v-model="ruleForm.certificateNo"
                  maxlength="30"
                  placeholder="请输入证件号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法人联系电话:" prop="legalTelephone">
                <el-input
                  v-model="ruleForm.legalTelephone"
                  maxlength="30"
                  placeholder="请输入法人联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div
          v-if="ruleForm.certificateType != 1 && ruleForm.certificateType != ''"
        >
          <nav-title class="mt2" title="经办人信息"></nav-title>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="经办人姓名:"
                prop="handlerName"
                :rules="
                  ruleForm.certificateType == 1
                    ? [{ required: false }]
                    : rules.handlerName
                "
              >
                <el-input
                  v-model="ruleForm.handlerName"
                  maxlength="300"
                  placeholder="请输入经办人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经办人身份证号:" prop="handlerIdNumber">
                <el-input
                  v-model="ruleForm.handlerIdNumber"
                  maxlength="300"
                  placeholder="请输入经办人身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="正面证件附件:" prop="handlePathFront">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.handlePathFrontImgurl"
                    class="previewimg"
                    @mouseenter="previewimg(ruleForm.handlePathFrontImgurl, 4)"
                    @mouseleave="previewimg('')"
                  >
                    <el-image
                      v-if="
                        commonHandleCheck(ruleForm.handlePathFront) == 'pdf'
                      "
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>

                    <el-image
                      v-else
                      ref="previewImg4"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.handlePathFrontImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg4"
                        class="imgBtn"
                        @click="handlePreview(4)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.handlePathFront)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess4"
                  ></fileUpload>
                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="反面证件附件:" prop="handlePathBack">
                <div class="flex_end">
                  <div
                    v-if="ruleForm.handlePathBackImgurl"
                    class="previewimg"
                    @mouseenter="previewimg(ruleForm.handlePathBackImgurl, 5)"
                    @mouseleave="previewimg('')"
                  >
                    <el-image
                      v-if="commonHandleCheck(ruleForm.handlePathBack) == 'pdf'"
                      class="img"
                      style="width: 96px; height: 140px"
                      :src="emptyImg"
                      fit="contain"
                    ></el-image>
                    <el-image
                      v-else
                      ref="previewImg5"
                      class="img"
                      :preview-src-list="previewImgList"
                      style="width: 96px; height: 140px"
                      :src="ruleForm.handlePathBackImgurl"
                      fit="contain"
                    ></el-image>
                    <transition name="el-zoom-in-bottom">
                      <div
                        v-show="showpreviewimg5"
                        class="imgBtn"
                        @click="handlePreview(5)"
                      >
                        查 看
                      </div>
                    </transition>
                  </div>
                  <fileUpload
                    :filetext="filetext(ruleForm.handlePathBack)"
                    :limit="0"
                    :file-size="1.8"
                    accept=".jpg,.jpeg,.png"
                    :upload-url="uploadUrl"
                    @handleSuccess="handleFileSuccess5"
                  ></fileUpload>
                  <p style="margin-left: 10px" class="tips">
                    备注：格式仅限.jpg .jpeg .png
                    ，上限1.8M，请尽量上传清晰可见的附件
                  </p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="证件生效时间:"
                prop="handlePeriodStart"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.handlePeriodStart"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="证件失效时间:"
                prop="handlePeriodEnd"
                class="ignore-label-after"
              >
                <el-date-picker
                  v-model="ruleForm.handlePeriodEnd"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="ruleForm.handleLongTernFlag"
                >
                </el-date-picker>
                <el-checkbox
                  v-model="ruleForm.handleLongTernFlag"
                  class="is-longtime"
                  @change="checkboxChange($event, 3)"
                  >长期有效</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="经办人手机号码:" prop="handlerTelephone">
                <el-input
                  v-model="ruleForm.handlerTelephone"
                  maxlength="30"
                  placeholder="请输入经办人手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="agreement">
          <el-row :gutter="20">
            <!-- <el-col :span="12">
                          <el-form-item label-width="0px">
                            <el-checkbox v-model="ruleForm.agreement"  name="type"/>
                            <span class="agreementText" @click="ruleForm.agreement=!ruleForm.agreement">
                                我已了解<span @click.stop="responsibilityShow">《廉洁从业责任书》</span> 
                          </span>
                        </el-form-item>
                        </el-col> -->
            <el-col :span="24">
              <el-form-item label-width="0px">
                <div class="next">
                  <el-button type="primary" @click="cancel">取消</el-button>
                  <el-button
                    type="primary"
                    :loading="btnLoading"
                    @click="submitForm('ruleForm')"
                    >提交审核</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <previewPDF
        :show.sync="pdf.showPDF"
        :title="pdf.title"
        :pdf-url="pdf.pdfUrl"
      ></previewPDF>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/pay/index';
import userApi from '@/modules/projectA/api/user/index';
import navTitle from './comments/navTitle.vue';
import fileUpload from './comments/fileUpload.vue';
import previewPDF from './comments/previewPDF.vue';
import { gateway } from '../../api/config.js';
import { validateCreditCode, email, mobile } from '../../utils/verification.js';

export default {
  components: {
    navTitle,
    fileUpload,
    previewPDF,
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    const checkLicensePeriodStart = (rule, value, callback) => {
      if (value === null && !this.ruleForm.licensePeriodStart) {
        callback(new Error('请选择营业执照生效时间'));
      } else {
        callback();
      }
    };
    const checkLicensePeriodEnd = (rule, value, callback) => {
      if (value === null && !this.ruleForm.licensePeriodEnd) {
        callback(new Error('请选择营业执照失效时间'));
      } else {
        callback();
      }
    };

    const checkCertificatePeriodStart = (rule, value, callback) => {
      if (value == null && !this.ruleForm.certificatePeriodStart) {
        callback(new Error('请选择法人证件生效时间'));
      } else {
        callback();
      }
    };
    const checkCertificatePeriodEnd = (rule, value, callback) => {
      if (value == null && !this.ruleForm.certificatePeriodEnd) {
        callback(new Error('请选择法人证件失效时间'));
      } else {
        callback();
      }
    };
    const checkHandlePeriodStart = (rule, value, callback) => {
      if (value == null && !this.ruleForm.handleLongTernFlag) {
        callback(new Error('请选择经办人证件生效时间'));
      } else {
        callback();
      }
    };
    const checkHandlePeriodEnd = (rule, value, callback) => {
      if (value == null && !this.ruleForm.handleLongTernFlag) {
        callback(new Error('请选择经办人证件失效时间'));
      } else {
        callback();
      }
    };
    return {
      /// //////////////chianPayMent////////////////
      btnLoading: false,
      showpreviewimg1: false,
      showpreviewimg2: false,
      showpreviewimg3: false,
      showpreviewimg4: false,
      showpreviewimg5: false,
      showpreviewimg6: false,
      scaleList: [
        { id: '01', name: '大型' },
        { id: '02', name: '中型' },
        { id: '03', name: '小型' },
        { id: '04', name: '微型' },
        { id: '98', name: '其他' },
      ], // 企业规模(01、大型 02、中型 03、小型 04、微型 98、其他)
      uploadUrl: '',
      certificateTypeList: [
        { id: '1', name: '身份证' },
        { id: '2', name: '外国护照' },
        { id: '3', name: '港澳居民来往内地通行证' },
        { id: '4', name: '台湾居民来往大陆通行证' },
      ], // 法人证件类型(1、身份证 2、外国护照 3、港澳居民来往内地通行证 4、台湾居民来往大陆通行证)
      /// //////////////chianPayMent////////////////
      ruleForm: {
        abbreviation: '', //	 企业简称
        address: '', //	 企业地址
        baseBankPath: '', //	 基本账户存款证明
        businessLicenseNo: '', //	 统一社会信用代码
        certificateNo: '', //	 法人证件号码
        certificatePathBack: '', //	 法人证件背面路径
        certificatePathFront: '', //	 法人证件正面路径
        certificatePeriod: '',
        certificatePeriodEnd: '', //	 法人证件有效期截止
        certificatePeriodStart: '', //	 法人证件有效期开始
        certificateType: '', //	 法人证件类型(1、身份证 2、外国护照 3、港澳居民来往内地通行证 4、台湾居民来往大陆通行证)
        companyId: '', //	 公司id
        companyName: '', // 企业全称
        email: '', //	 企业邮箱
        handlePathBack: '', //	 经办人证件背面路径
        handlePathFront: '', //	 经办人证件正面路径
        handlePeriod: '',
        handlePeriodEnd: '', //	 经办人证件有效期截止
        handlePeriodStart: '', //	 经办人证件有效期开始
        handlerIdNumber: '', //	 经办人证件号码
        handlerName: '', //	 经办人姓名
        handlerTelephone: '', //	 经办人手机号
        legalName: '', //	 法人姓名
        legalTelephone: '', //	 法人联系电话
        licensePath: '', //	 营业执照附件路径
        licensePeriod: '',
        licensePeriodEnd: '', //	 营业执照有效期截止
        licensePeriodStart: '', //	 营业执照有效期开始
        scale: '', //	string 企业规模(01、大型 02、中型 03、小型 04、微型 98、其他),
        licenseLongTernFlag: false, // 1、营业执照长期有效0、未长期有效
        handleLongTernFlag: false, // 经办人证件长期有效标志 1、长期有效0、未长期有效
        certificateLongTernFlag: false, // 法人证件长期有效标志 1、长期有效0、未长期有效
        licensePathImgurl: '', // 营业执照 回显图片
        certificatePathFrontImgurl: '', // 法人证件正面  回显图片
        certificatePathBackImgurl: '', // 法人证件背面  回显图片
        handlePathFrontImgurl: '', // 经办人证件正面  回显图片
        handlePathBackImgurl: '', // 经办人证件背面  回显图片
        agreement: false,
        baseBankPathImgurl: '',
      },
      previewImgList: [],
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: ['blur'] },
        ],
        abbreviation: [
          { required: true, message: '请输入公司简称', trigger: ['blur'] },
        ],
        address: [
          { required: true, message: '请输入企业地址', trigger: ['blur'] },
        ],
        email: [{ required: true, validator: email, trigger: ['blur'] }],
        scale: [
          { required: true, message: '请选择企业规模', trigger: 'change' },
        ],
        businessLicenseNo: [
          { required: true, validator: validateCreditCode, trigger: ['blur'] },
        ],
        licensePeriodStart: [
          {
            required: true,
            validator: checkLicensePeriodStart,
            trigger: ['blur', 'change'],
          },
        ],
        licensePeriodEnd: [
          {
            required: true,
            validator: checkLicensePeriodEnd,
            trigger: ['blur', 'change'],
          },
        ],
        licensePath: [
          {
            required: true,
            message: '请上传营业执照附件',
            trigger: ['blur', 'change'],
          },
        ],
        legalName: [
          { required: true, message: '请输入法人姓名', trigger: ['blur'] },
        ],
        certificateType: [
          {
            required: true,
            message: '请选择法人证件类型',
            trigger: ['change'],
          },
        ],
        certificatePathFront: [
          {
            required: true,
            message: '请上传法人正面证件附件',
            trigger: ['change'],
          },
        ],
        certificatePathBack: [
          {
            required: true,
            message: '请上传法人反面证件附件',
            trigger: ['change'],
          },
        ],
        certificateNo: [
          { required: true, message: '请输入法人证件号码', trigger: ['blur'] },
        ],
        certificatePeriodStart: [
          {
            required: true,
            validator: checkCertificatePeriodStart,
            trigger: ['blur', 'change'],
          },
        ],
        certificatePeriodEnd: [
          {
            required: true,
            validator: checkCertificatePeriodEnd,
            trigger: ['blur', 'change'],
          },
        ],
        legalTelephone: [
          { required: true, validator: mobile, trigger: ['blur'] },
        ],
        handlerName: [
          { required: true, message: '请输入经办人姓名', trigger: ['blur'] },
        ],
        handlerIdNumber: [
          {
            required: true,
            message: '请输入经办人证件号码',
            trigger: ['blur'],
          },
        ],
        handlePathFront: [
          {
            required: true,
            message: '请上传经办人正面证件附件',
            trigger: ['change'],
          },
        ],
        handlePathBack: [
          {
            required: true,
            message: '请上传经办人反面证件附件',
            trigger: ['change'],
          },
        ],
        handlePeriodStart: [
          {
            required: true,
            validator: checkHandlePeriodStart,
            trigger: ['blur'],
          },
        ],
        handlePeriodEnd: [
          {
            required: true,
            validator: checkHandlePeriodEnd,
            trigger: ['blur'],
          },
        ],
        handlerTelephone: [
          { required: true, validator: mobile, trigger: ['blur'] },
        ],
        baseBankPath: [
          {
            required: true,
            message: '请上传基本账户存款证明',
            trigger: ['change'],
          },
        ],
      },
      pdf: {
        showPDF: false,
        title: '预览PDF',
        pdfUrl: '',
      },
      emptyImg: require('@/assets/img/pay/empty.png'),
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newval) {
        if (newval.companyId) {
          this.queryPayAccountInfo();
        }
      },
    },
  },
  mounted() {
    this.uploadUrl = `${gateway}/api/payment/oss/fileUploadForLicence`;
  },
  methods: {
    /// ////////////chianPayment//////////////////////////////
    async queryPayAccountInfo() {
      const res = await Api.queryPayAccountInfo();
      if (res.success) {
        Object.assign(this.ruleForm, res.data);
        if (this.ruleForm.licensePath) {
          this.paymentGetSupplierLicence(this.ruleForm.licensePath, 1);
        }
        if (this.ruleForm.certificatePathFront) {
          this.paymentGetSupplierLicence(this.ruleForm.certificatePathFront, 2);
        }
        if (this.ruleForm.certificatePathBack) {
          this.paymentGetSupplierLicence(this.ruleForm.certificatePathBack, 3);
        }
        if (this.ruleForm.handlePathFront) {
          this.paymentGetSupplierLicence(this.ruleForm.handlePathFront, 4);
        }
        if (this.ruleForm.handlePathBack) {
          this.paymentGetSupplierLicence(this.ruleForm.handlePathBack, 5);
        }
        if (this.ruleForm.baseBankPath) {
          this.paymentGetSupplierLicence(this.ruleForm.baseBankPath, 6);
        }
        if (!this.ruleForm.licenseLongTernFlag) {
          this.ruleForm.licenseLongTernFlag = false;
          this.ruleForm.licensePeriod = [
            this.ruleForm.licensePeriodStart,
            this.ruleForm.licensePeriodEnd,
          ];
        } else {
          this.ruleForm.licensePeriod = '';
          this.ruleForm.licenseLongTernFlag = true;
        }

        if (this.ruleForm.handleLongTernFlag == 1) {
          this.ruleForm.handlePeriod = '';
          this.ruleForm.handleLongTernFlag = true;
        } else {
          this.ruleForm.handleLongTernFlag = false;
          if (this.ruleForm.handlePeriod) {
            this.ruleForm.handlePeriod = [
              this.ruleForm.handlePeriodStart,
              this.ruleForm.handlePeriodEnd,
            ];
          }
        }
        if (!this.ruleForm.certificateLongTernFlag) {
          this.ruleForm.certificateLongTernFlag = false;
          this.ruleForm.certificatePeriod = [
            this.ruleForm.certificatePeriodStart,
            this.ruleForm.certificatePeriodEnd,
          ];
        } else {
          this.ruleForm.certificatePeriod = '';
          this.ruleForm.certificateLongTernFlag = true;
        }
        this.ruleForm.certificateType =
          this.ruleForm.certificateType.toString();
        this.ruleForm.agreement = true;
      }
    },
    async queryCompanyInfoById(id) {
      const parmas = {
        companyId: id,
      };
      const res = await userApi.queryCompanyInfoById(parmas);
      if (res.code == 200) {
        // （101：身份证、102：护照、103：其他
        if (res.data.certificateType == 101) {
          this.ruleForm.certificateType = '1';
        } else if (res.data.certificateType == 102) {
          this.ruleForm.certificateType = '2';
        }
        this.ruleForm.companyId = res.data.companyId;
        this.ruleForm.companyName = res.data.companyName;
        this.ruleForm.abbreviation = res.data.abbreviation;
        this.ruleForm.businessLicenseNo = res.data.businessLicenseNo;
        this.ruleForm.email = res.data.email;
        this.ruleForm.legalName = res.data.legalRepresentative;
        this.ruleForm.certificateNo = res.data.idNumber;
        this.ruleForm.address = res.data.address;
      }
    },
    filetext(val) {
      if (val) {
        return '重新上传';
      }
      return '上传附件';
    },
    previewimg(url, index) {
      if (url) {
        if (index == 1) {
          this.showpreviewimg1 = true;
        }
        if (index == 2) {
          this.showpreviewimg2 = true;
        }
        if (index == 3) {
          this.showpreviewimg3 = true;
        }
        if (index == 4) {
          this.showpreviewimg4 = true;
        }
        if (index == 5) {
          this.showpreviewimg5 = true;
        }
        if (index == 6) {
          this.showpreviewimg6 = true;
        }
        this.previewImgList = [url];
      } else {
        this.showpreviewimg1 = false;
        this.showpreviewimg2 = false;
        this.showpreviewimg3 = false;
        this.showpreviewimg4 = false;
        this.showpreviewimg5 = false;
        this.showpreviewimg6 = false;
      }
    },
    handlePreview(index) {
      if (this.previewImgList[0].indexOf('.pdf') > 0) {
        this.pdf.showPDF = true;
        this.pdf.pdfUrl = this.previewImgList[0];
        return;
      }
      if (index == 1) {
        this.$refs.previewImg1.showViewer = true;
      }
      if (index == 2) {
        this.$refs.previewImg2.showViewer = true;
      }
      if (index == 3) {
        this.$refs.previewImg3.showViewer = true;
      }
      if (index == 4) {
        this.$refs.previewImg4.showViewer = true;
      }
      if (index == 5) {
        this.$refs.previewImg5.showViewer = true;
      }
      if (index == 6) {
        this.$refs.previewImg6.showViewer = true;
      }
    },
    checkboxChange(val, index) {
      if (index == 1 && val) {
        this.ruleForm.licensePeriodEnd = '';
        this.$refs.ruleForm.clearValidate('licensePeriodEnd');
      } else if (index == 2 && val) {
        this.ruleForm.certificatePeriodEnd = '';
        this.$refs.ruleForm.clearValidate('certificatePeriodEnd');
      } else if (index == 3 && val) {
        this.ruleForm.handlePeriodEnd = '';
        this.$refs.ruleForm.clearValidate('handlePeriodEnd');
      }
    },
    async paymentGetSupplierLicence(filePath, index) {
      const parmas = {
        filePath,
      };
      const res = await Api.paymentGetSupplierLicence(parmas);
      if (res.code == 200) {
        if (index == 1) {
          this.ruleForm.licensePathImgurl = res.data;
        } else if (index == 2) {
          this.ruleForm.certificatePathFrontImgurl = res.data;
        } else if (index == 3) {
          this.ruleForm.certificatePathBackImgurl = res.data;
        } else if (index == 4) {
          this.ruleForm.handlePathFrontImgurl = res.data;
        } else if (index == 5) {
          this.ruleForm.handlePathBackImgurl = res.data;
        } else if (index == 6) {
          this.ruleForm.baseBankPathImgurl = res.data;
        }
      }
    },
    // 上传成功的钩子
    handleFileSuccess1(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.licensePath = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 1);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },
    handleFileSuccess2(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.certificatePathFront = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 2);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },
    handleFileSuccess3(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.certificatePathBack = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 3);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },
    handleFileSuccess4(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.handlePathFront = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 4);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },
    handleFileSuccess5(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.handlePathBack = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 5);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },
    handleFileSuccess6(response, file, fileList) {
      console.log(file, fileList);
      if (response.success) {
        this.$refs.ruleForm.clearValidate();
        this.ruleForm.baseBankPath = response.data.url;
        this.paymentGetSupplierLicence(response.data.url, 6);
      } else {
        this.$message({
          message: response.message,
          type: 'error',
        });
      }
    },

    // 取消
    cancel() {
      this.$router.push('/accountManagement');
    },
    handleData() {
      const params = {};
      Object.assign(params, this.ruleForm);
      if (!params.licenseLongTernFlag) {
        params.licenseLongTernFlag = 0;
        params.licensePeriodStart += ' 00:00:00';
        params.licensePeriodEnd += ' 00:00:00';
      } else {
        params.licenseLongTernFlag = 1;
        params.licensePeriodStart += ' 00:00:00';
        params.licensePeriodEnd = '9999-12-31 00:00:00';
      }
      if (!params.certificateLongTernFlag) {
        params.certificateLongTernFlag = 0;
        params.certificatePeriodStart += ' 00:00:00';
        params.certificatePeriodEnd += ' 00:00:00';
      } else {
        params.certificateLongTernFlag = 1;
        params.certificatePeriodStart += ' 00:00:00';
        params.certificatePeriodEnd = '9999-12-31' + ' 00:00:00';
      }
      if (params.handleLongTernFlag) {
        params.handleLongTernFlag = 1;
        params.handlePeriodStart += ' 00:00:00';
        params.handlePeriodEnd = '9999-12-31' + ' 00:00:00';
      } else {
        params.handleLongTernFlag = 0;
        params.handlePeriodStart = params.handlePeriodStart
          ? `${params.handlePeriodStart} 00:00:00`
          : '';
        params.handlePeriodEnd = params.handlePeriodEnd
          ? `${params.handlePeriodEnd} 00:00:00`
          : '';
        if (params.handlePeriodStart) {
          params.handlePeriod = [
            params.handlePeriodStart,
            params.handlePeriodEnd,
          ];
        }
      }

      return params;
    },

    testDate() {
      // 营业执照
      if (
        !this.ruleForm.licensePeriodEnd &&
        !this.ruleForm.licenseLongTernFlag
      ) {
        this.ruleForm.licensePeriodEnd = null;
      }
      // 法人
      if (
        !this.ruleForm.certificatePeriodEnd &&
        !this.ruleForm.certificateLongTernFlag
      ) {
        this.ruleForm.certificatePeriodEnd = null;
      }
      // 经办人
      if (!this.ruleForm.handlePeriodEnd && !this.ruleForm.handleLongTernFlag) {
        this.ruleForm.handlePeriodEnd = null;
      }
    },
    // 提交
    submitForm(formName) {
      this.testDate();
      if (!this.ruleForm.agreement) {
        this.$message({
          message: '请阅读并勾选协议！',
          type: 'error',
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;

          this.modifyPayAccount();
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName('is-error');
            isError[0].querySelector('input').focus();
          }, 100);
          this.btnLoading = false;
        }
      });
    },
    async addPayAccount() {
      const parmas = this.handleData();
      const res = await Api.addPayAccount(parmas);
      if (res.code == 200) {
        this.btnLoading = false;
        this.$parent.nextStep(2);
      }
    },
    async modifyPayAccount() {
      const parmas = this.handleData();
      const res = await Api.modifyPayAccount(parmas);
      this.btnLoading = false;
      if (res.code == 200) {
        this.cancel();
      }
    },
    // 获取文件格式
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },
  },
};
</script>

<style lang="scss" scoped>
.chinaPayment {
  background: #fff;
}
.enterprise-info {
  // margin: 0 auto;
  padding: 20px;
  min-width: 1050px;

  ::v-deep .el-input__inner {
    border-radius: 0;
  }
  ::v-deep .el-range-separator {
    min-width: 30px;
  }
  .agreement {
    margin-top: 30px;
    .agreementText {
      margin-left: 5px;
      > span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
  .demo-ruleForm {
    .form-item {
      width: 100%;
    }
  }
  .is-checked {
    ::v-deep .el-checkbox__inner {
      background-color: #2587ff;
      border-color: #2587ff;

      &::after {
        border: 1px solid #fff;
        border-left: 0;
        border-top: 0;
      }
    }
  }
  ::v-deep .el-checkbox__inner::after {
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
  }
  ::v-deep .el-radio__label {
    color: #333;
  }

  ::v-deep .is-checked + .el-checkbox__label {
    color: #333;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #333;
  }
  .next {
    // display: flex;
    // position: relative;
    // left: -92px;
    // top: 8px;
    text-align: center;
    .el-button {
      border-radius: 0px;
      padding: 0;
      &:nth-of-type(1) {
        width: 80px;
        height: 30px;

        margin-left: 0;
        color: #333;
        background-color: #fffdfa;
        border: 1px solid #d9d9d9;

        &:hover {
          color: #2587ff;
          border: 1px solid #2587ff;
        }
      }

      &:nth-of-type(2) {
        margin-left: 20px;
        width: 80px;
        height: 30px;
      }
    }
  }
}

.mt2 {
  margin-bottom: 20px;
}
.mt3 {
  margin-bottom: 30px;
}
.tips {
  font-size: 14px;
  color: #999999;
}
.flex_end {
  display: flex;
  align-items: flex-end;
  .previewimg {
    width: 180px;
    height: 180px;
    background: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    position: relative;
    .imgBtn {
      position: absolute;
      bottom: 0;
      height: 30px;
      line-height: 30px;
      text-align: center;
      width: 100%;
      background: rgba(34, 34, 34, 0.6);
      color: #fff;
      cursor: pointer;
    }
  }
}
.is-longtime {
  margin-left: 5px;
}
</style>
